import { render, staticRenderFns } from "./task-read-mode.vue?vue&type=template&id=38cac665&scoped=true"
import script from "./task-read-mode.vue?vue&type=script&lang=js"
export * from "./task-read-mode.vue?vue&type=script&lang=js"
import style0 from "./task-read-mode.vue?vue&type=style&index=0&id=38cac665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cac665",
  null
  
)

export default component.exports